import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PersonStammMasterId } from '../../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonAdresseListEntryMeta, PersonStammMasterDetailEntryMeta, PersonstammpersonService } from '../../../core/personstamm-api';
import { DayMonthYearDatePipe } from '../../../shared/pipes/simple/dayMonthYearDate.pipe';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { TimepointService } from '../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { HistoryMode } from '../../../core/services/HistoryMode';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { ListLoaderPreloaded } from '../../../shared/components/list-loader/list-loader-preloaded';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktStammpersonComponent } from '../../../shared/kompaktdarstellung/stammperson/kompakt-stammperson.component';
import { PersonstammAdressenComponent } from '../detail/adressen/personstamm-adressen.component';
import { CapSpinnerSmallComponent } from '../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { TooltipPersonstammPipe } from '../../../shared/pipes/simple/tooltip-personstamm.pipe';
import { PermissionResponse } from '../../../core/base-api';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-personstamm-view',
  templateUrl: './personstamm-view.component.html',
  styleUrls: ['./personstamm-view.component.scss'],
  imports: [
    KopfdatenelementComponent,
    LinkComponent,
    KompaktStammpersonComponent,
    PersonstammAdressenComponent,
    CapSpinnerSmallComponent,
    TranslatePipe,
    TooltipPersonstammPipe
  ]
})
export class PersonstammViewComponent implements OnInit, OnDestroy {
  navTargets = NavTarget;
  @Input()
  historyMode = HistoryMode.HistoryMode.OHNE_HIST;
  @Input()
  personStammMasterId: PersonStammMasterId;

  public entry: PersonStammMasterDetailEntryMeta;
  adressen: ListLoader<PersonAdresseListEntryMeta>;
  hasPermissionAdresse: boolean;
  private subscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private personstammService: PersonstammpersonService,
    private permissionService: AppPermissionService,
    public dayMonthYearDatePipe: DayMonthYearDatePipe,
    private zeitpunktService: TimepointService
  ) {
    keysToTranslate<string>(['Datenquelle', 'Fremdsystem', 'Grundbuch']);
    this.hasPermissionAdresse = this.permissionService.hasPermission(PermissionsEnum.ADRESSSPERRE);
  }

  ngOnInit(): void {
    this.loadPersonstamm();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  showAdressen(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    let hasAdresssperre = auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.ADRESS_SPERRE;
    return !hasAdresssperre || (hasAdresssperre && this.hasPermissionAdresse);
  }

  private loadPersonstamm() {
    this.subscription = this.personstammService
      .loadById(this.personStammMasterId.id, this.historyMode, null, this.zeitpunktService.timepointCtx.timepointIso, null)
      .subscribe((entry) => {
        this.entry = entry;
        this.adressen = new ListLoaderPreloaded<PersonAdresseListEntryMeta>(15, 1, entry.adressen);
      });
  }
}
